import React from 'react';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const GHNextStepContent = () => {
  return (
    <>
      <div className='flex flex-col gap-y-4 sm:gap-y-10'>



        <div className='grid grid-cols-1 sm:grid-cols-2 gap-y-8'>
          <div className='flex flex-col gap-y-2 sm:gap-y-8'>
            <div className='flex items-start flex-wrap gap-x-2'>
              <div className='flex items-center font-bold text-2xl'> Step 1:</div>
              <div className='text-2xl'>
                Your contact information
              </div>
            </div>
            <div className='flex justify-center'><AiOutlineCheckCircle className='text-secondary text-7xl mr-16' /></div>
          </div>

          <div className='flex flex-col sp ace-y-4'>
            <p className='text-2xl'> <b>Step 2:</b> Click The Button Below To Fill Out Our Online Group Census Form</p>
            <Link to="/group-census">
              <button className='btn btn-secondary text-base-100 w-full borde-4 border-base-100'>Complete Group Census Form</button>
            </Link>
            <p>If you already have a group census form completed and wish to email it in your own format instead of completing it online, please send it to&nbsp;
              <a href='mailto:benefits@insuranceenterpriseusa.com?subject=Group%20Census%20Form%20Attached%20for%20Proposal' target='_blank' rel='noopener noreferrer' className='font-bold underline'>benefits@insuranceenterpriseusa.com</a>,
              and one of our group specialists will provide a group proposal within 24 business hours.</p>
          </div>
        </div>

      </div>

    </>
  );
}

export default GHNextStepContent;
